module.exports = __webpack_public_path__ + "static/media/23-min.03eb2133.jpg";